export const techStack = [
  { name: 'Angular', icon: 'Triangle' },
  { name: 'Svelte / SvelteKit', icon: 'Layers' },
  { name: 'C# / ASP.NET', icon: 'Code' },
  { name: 'TypeScript', icon: 'FileCode2' },
  { name: 'Python', icon: 'Terminal' },
  { name: 'LangChain & Ollama', icon: 'Link' },
  { name: 'AI Agents & LLMs', icon: 'Brain' },
  { name: 'Bases de Datos SQL', icon: 'Database' },
  { name: 'RxJS & LINQ', icon: 'Activity' },
  { name: 'Git & Linux', icon: 'GitBranch' }
];
